import * as yup from "yup";
const validations = yup.object().shape({
  name: yup.string().required("validationMessages.required"),
  horizontal_spiral_count: yup.number().required("validationMessages.required"),
  vertical_spiral_count: yup.number().required("validationMessages.required"),
});

export default validations;
